import {
  jb_article_page_hero_css_default
} from "./chunk.ZRCTJ2H3.js";
import {
  Spaceable
} from "./chunk.MFPI4EPN.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  n
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-article-page-hero/jb-article-page-hero.ts
var JbArticlePageHero = class extends Spaceable(r) {
  _getContentSpacingProperties() {
    return {
      grid: "legacy",
      colsMdUp: "none",
      horizontal: "full-width",
      type: "text"
    };
  }
  _hasAllToolBarProperties() {
    return this.toolBarButtons?.length > 0 && this.toolBarMailSubject !== void 0 && this.toolBarShareBarLabel !== void 0 && this.toolBarShareServices?.length > 0 && this.toolBarUrl !== void 0;
  }
  render() {
    return ke`
      <article>
        ${this.breadcrumbs ? ke`
              <jb-breadcrumbs>
                ${this.breadcrumbs.backlink && ke`<jb-breadcrumbs-back-link
                  .link=${this.breadcrumbs.backlink.link}
                  .text=${this.breadcrumbs.backlink.text}
                  slot="backlink"
                ></jb-breadcrumbs-back-link>`}
                ${this.breadcrumbs.items?.map(
      (breadcrumb) => ke`<jb-breadcrumbs-item
                      .link=${breadcrumb.link}
                      .text=${breadcrumb.text}
                      slot="items"
                    ></jb-breadcrumbs-item>`
    )}
              </jb-breadcrumbs>
            ` : D}

        <header>
          ${this.headline ? ke`<h1>${this.headline}</h1>` : D}
          <div>
            <span>${this.date} ${this.author}</span>
            <span><jb-clock-icon></jb-clock-icon>${this.readingTime}</span>
          </div>
        </header>

        <figure>
          <jb-picture
            .alt=${this.image.picture.alt}
            .imgData=${this.image.picture.imgData}
            .lazy=${this.image.picture.lazy}
          ></jb-picture>
          <figcaption>
            <div class="caption-wrapper">
              ${this.image.caption ? ke`<p class="caption">${this.image.caption}</p>` : D}
              ${this.image.text ? ke`<p class="text">${this.image.text}</p>` : D}
              ${this.image.credit ? ke`<p class="credit">${this.image.credit}</p>` : D}
            </div>
          </figcaption>
        </figure>

        ${this.text ? ke`<p class="intro-text">${this.text}</p>` : D}
        ${this._hasAllToolBarProperties() ? ke`
              <jb-article-tool-bar
                .articleTitle=${this.headline}
                .buttons=${this.toolBarButtons}
                .mailSubject=${this.toolBarMailSubject}
                .title=${this.toolBarShareBarLabel}
                .shareBarLabel=${this.toolBarShareBarLabel}
                .shareServices=${this.toolBarShareServices}
                .url=${this.toolBarUrl}
              ></jb-article-tool-bar>
            ` : D}
      </article>
    `;
  }
};
JbArticlePageHero.styles = [reset_css_default, jb_article_page_hero_css_default];
__decorateClass([
  n()
], JbArticlePageHero.prototype, "author", 2);
__decorateClass([
  n({ type: Object })
], JbArticlePageHero.prototype, "breadcrumbs", 2);
__decorateClass([
  n()
], JbArticlePageHero.prototype, "date", 2);
__decorateClass([
  n()
], JbArticlePageHero.prototype, "headline", 2);
__decorateClass([
  n({ type: Object })
], JbArticlePageHero.prototype, "image", 2);
__decorateClass([
  n()
], JbArticlePageHero.prototype, "readingTime", 2);
__decorateClass([
  n()
], JbArticlePageHero.prototype, "text", 2);
__decorateClass([
  n({ type: Object })
], JbArticlePageHero.prototype, "toolBarButtons", 2);
__decorateClass([
  n()
], JbArticlePageHero.prototype, "toolBarMailSubject", 2);
__decorateClass([
  n()
], JbArticlePageHero.prototype, "toolBarShareBarLabel", 2);
__decorateClass([
  n({ type: Array })
], JbArticlePageHero.prototype, "toolBarShareServices", 2);
__decorateClass([
  n()
], JbArticlePageHero.prototype, "toolBarUrl", 2);
JbArticlePageHero = __decorateClass([
  customElement("jb-article-page-hero")
], JbArticlePageHero);

export {
  JbArticlePageHero
};
